module.exports = __webpack_public_path__ + "img/img2.a59921e4.jpg";